import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getPath } from '../../utils/getPath';
import './CategoryCard.scss';
import { Typography } from '@material-ui/core';

const CategoryCard = props => {
    const { id, name } = props.data;

    const renderIcon = id => {
        switch (id) {
            case '1':
                return getPath('public/img/categories/cat_1.svg');
            case '2':
                return getPath('public/img/categories/cat_2.svg');
            case '3':
                return getPath('public/img/categories/cat_3.svg');
            case '4':
                return getPath('public/img/categories/cat_4.svg');
            case '20':
                return getPath('public/img/categories/cat_20.svg');
            case '23':
                return getPath('public/img/categories/cat_23.svg');
            case '27':
                return getPath('public/img/categories/cat_27.svg');
            case '54':
                return getPath('public/img/categories/cat_54.svg');
            case '34':
                return getPath('public/img/categories/cat_34.svg');
            case '43':
                return getPath('public/img/categories/cat_43.svg');
            case '49':
                return getPath('public/img/categories/cat_49.svg');
            case '53':
                return getPath('public/img/categories/cat_53.svg');

            default:
                return '';
        }
    };

    return (
        <Link to={`/catalog/${id}`} className="lk-category-card">
            <div className="lk-category-card__icon">
                <img src={renderIcon(id)} alt="" />
            </div>
            <Typography variant="body2" className="lk-category-card__title">
                {name}
            </Typography>
        </Link>
    );
};

CategoryCard.propTypes = {
    icon: PropTypes.string,
    children: PropTypes.string,
};

export default CategoryCard;
